import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ZykainWebsite from './components/ZykainWebsite';
import ZykainPrivacyPolicy from './components/ZykainPrivacyPolicy';
import ZykainTermsOfService from './components/ZykainTermsOfService';
import SprintReporterFAQ from './components/SprintReporterFAQ';
import AtlassianSupportForm from './components/AtlassianSupportForm';
import SecurityPolicy from './components/SecurityPolicy';
import SLAPolicy from './components/ServiceLevelPolicy';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ZykainWebsite />} />
        <Route path="/privacy-policy" element={<ZykainPrivacyPolicy />} />
        <Route path="/terms-of-service" element={<ZykainTermsOfService />} />
        <Route path='/sprint-reporter-faq' element={<SprintReporterFAQ/>}/>
        <Route path='/support' element={<AtlassianSupportForm/>}/>
        <Route path='/security-policy' element={<SecurityPolicy/>}/>
        <Route path='/sla-policy' element={<SLAPolicy/>}/>

      </Routes>
    </Router>
  );
}

export default App;